type ClickEventProps = {
    ctaUrl: string;
    ctaValue: string;
    pageZone: string;
    pagePath: string | undefined;
};

export default function clickEventData({ ctaUrl, ctaValue, pageZone, pagePath }: ClickEventProps) {
    const label = `Content:${pageZone}`;
    const source = pagePath || window.location.pathname;
    const eventDetail = `${source};${ctaUrl};${pageZone};${ctaValue}`;

    return {
        label,
        eventDetail,
        navigationDetail: ctaValue,
    };
}
